// extracted by mini-css-extract-plugin
module.exports = {"separatorWrapper":"styles_separatorWrapper__qi5Be","sectionWidth":"styles_sectionWidth__X0mBl","separator":"styles_separator__N95Lk"};